<template>
    <setup_content title="Метод сравнения продаж" class="sales">
        <add_correction ref="addCorrection" @add_attr="add_correction" />

        <setup_frame class="factors-frame"
            :title="'Удельный показатель кадастровой стоимости типового (эталонного) объекта недвижимости' + (uprs_average ? ': ' + uprs_average : '')"
            :tooltip="uprs_average ? 'Среднее значение удельных показателей цены объектов-аналогов' : null"
        >
            <factors :controller="controller" is_sales />
        </setup_frame>

        <b-navbar class="sales-corrections_navbar">
            <b-navbar-brand>Объекты-аналоги</b-navbar-brand>

            <b-button variant="outline-primary" v-on:click="add_correction_modal" title="Добавить корректировку" v-b-tooltip:fullscreen.hover.bottomright>
                <base-icon name="add" />
            </b-button>
        </b-navbar>

        <b-overlay :show="wait">
            <div class="w-100 table_analogues_container">
                <b-table class="table_analogues" ref="table_analogues" :fields="fields" :items="items" @hook:updated="restyle_table" >
    
                    <template #head()="{ field }">
                        <div v-if="field.key == 'settings'" class="sticky-col button_col"><base-icon name="settings" /></div>
                        <div v-else-if="field.key == 'name'" class="sticky-col attr_col">{{ field.label }}</div>
                        <div v-else-if="field.key == 'ref_obj'" class="sticky-col ref_obj_col">{{ field.label }}</div>
                        <div v-else class="table_analogues_group-code">
                            <b-form-checkbox :checked="!field.bad" @change="(value) => set_not_exclude(field.key, value)" />
                            <router-link :to="'/analogues/' + field.key">{{ field.label }}</router-link>
                        </div>
                    </template>
    
                    <template #cell()="cell_data">

                        <div v-if="cell_data.field.key == 'settings'" class="sticky-col button_col">
                            <b-button v-if="cell_data.item.is_attr && !cell_data.item.is_uprs"
                                :class="cell_data.item.is_attr && cell_data.item.is_correction ? 'is_settings_button' : 'is_settings_button_attr'" 
                                size="sm" variant="outline-primary-dark"
                                @click="() => delete_correction(
                                    cell_data.item.id
                                        ? { attr_id : cell_data.item.id, order : cell_data.item.order }
                                        : { name : cell_data.item.name, order : cell_data.item.order }
                                    )"
                            >

                                <base-icon name="delete" />

                            </b-button>
                            <div v-else-if="cell_data.item.is_uprs" class="is_settings_uprs"></div>
                        </div>

                        <div v-else-if="cell_data.field.key == 'name'"
                            :class="cell_data.item.is_attr ? 'sticky-col attr_col is_attr' : 'sticky-col attr_col'"
                        >{{ cell_data.value }}</div>

                        <div v-else-if="cell_data.field.key == 'ref_obj'"
                            :class="cell_data.item.is_attr ? 'sticky-col ref_obj_col is_attr' : 'sticky-col ref_obj_col'"
                        >{{ cell_data.value }}</div>

                        <b-form-input v-else-if="cell_data.item.is_correction && cell_data.field.key !== 'name' && cell_data.field.key !== 'ref_obj'"
                            :class="cell_data.item.is_attr ? 'is_attr' : ''"
                            type="number" :gt="0" :value="cell_data.value"
                            @change="(value) => set_correction(cell_data.field.key, cell_data.item.id ? cell_data.item.id : cell_data.item.name, value)"
                        />

                        <div v-else-if="cell_data.item.is_attr" class="is_attr">{{ cell_data.value }}</div>

                        <template v-else>{{ round2(cell_data.value) }}</template>

                    </template>
                    
                    <template #custom-foot>
                        <tr v-if="uprs_average">
                            <td colspan="2" class="tfoot-td_sticky button_col">
                                Удельный показатель кадастровой стоимости, руб./кв.м
                            </td>
                            <td class="tfoot-td_sticky ref_obj_col tfoot-td_uprs">
                                {{ uprs_average }}
                            </td>
                            <td colspan="100%"></td>
                        </tr>
                        <tr v-if="cost_ref">
                            <td colspan="2" class="tfoot-td_sticky button_col">
                                Кадастровая стоимость, руб.
                            </td>
                            <td class="tfoot-td_sticky ref_obj_col">
                                {{ cost_ref }}
                            </td>
                        </tr>
                    </template>
                </b-table>
            </div>
        </b-overlay>
    </setup_content>
</template>

<script>
import api from "../../../../../../api";
import setup_content from "../../setup_assets/content"
import setup_frame from "../../setup_assets/frame"
import Reference_controller from "../controller";
import factors from "../factors"
import add_correction from "./add_correction"

export default {
    props :
	{
		controller : Reference_controller,
        active_step : String,
	},

    components :
    {
        setup_content,
        setup_frame,
        factors,
        add_correction
    },

    data()
    {
        return {
            wait : true,

            uprs_average : null,
            cost_ref : null,
            fields : null,
            items : null,
            attrs : null,

        }
    },

    beforeMount()
    {
        this.controller.set_analogues_corrections(() => this.update_analogues())
    },

    methods :
    {
        update_analogues()
        {
            this.wait = true

            this.controller.get_analogues_corrections()
                .then(({ fields, items, attrs, uprs_average, last_order, ref_obj, analogues_count }) => {
                    if (analogues_count == 0)
                    {
                        const h = this.$createElement
                        const messageVNode = [
                            h('div', {}, 'Данный метод невозможно использовать.'),
                            h('div', {}, 'Все объекты-аналоги не соответствуют условиям:'),
                            h('ul', { class : "mb-0" }, [
                                h('li', {}, 'наличие площади'),
                                h('li', {}, 'Вид права = "Купля-продажа" или "Результаты оценки рыночной стоимости"'),
                                h('li', {}, 'наличие значений выбранных ценообразующих факторов'),
                            ]),
                        ]
                        this.$bvModal.msgBoxOk(messageVNode, { okVariant: 'danger' })
                    }

                    let uprs_average_rounded
                    let cost_ref
                    
                    if (uprs_average)
                    {
                        uprs_average_rounded = api.roundToStr(uprs_average, 2)

                        if (ref_obj && ref_obj.area)
                        {
                            cost_ref = api.roundToStr(this.round2(uprs_average) * ref_obj.area, 2)
                        }
                    }

                    this.fields = fields
                    this.items = items
                    this.uprs_average =  uprs_average_rounded
                    this.cost_ref = cost_ref
                    this.attrs = attrs
                    this.last_order = last_order
                })
                .then(() => this.wait = false)
        },

        add_correction_modal()
        {
            this.$refs.addCorrection.execute(this.attrs)
        },

        add_correction({ attr_id, name })
        {
            this.wait = true

            this.controller.add_attr_correction({ attr_id, name, order : this.last_order+1 })
                .then(() => this.wait = false)
        },

        delete_correction({ attr_id, name, order })
        {
            this.wait = true

            this.controller.delete_attr_correction({ attr_id, name, order }).then(() => this.wait = false)
        },

        set_not_exclude(analogues_id, value)
        {
            this.wait = true

            api.call(this, "cadastral_analogues", "set_field",
                { id : analogues_id, field : "current_version.attrs.bad_reference", value : !value },
                () => this.update_analogues()
            )
        },

        set_correction(id, correction_id, value)
        {
            const _value = value == null || value == "" || value == undefined ? 1 : Number(value)

            this.controller.set_correction(id, correction_id, _value)
        },

        restyle_table()
        {
            const tds = [...this.$refs.table_analogues.$el.querySelectorAll("td.is_settings")]

            tds.forEach((td) => {
                if (td.querySelector(".is_settings_button_attr")) { td.setAttribute("rowspan", 3) }
                else if (td.querySelector(".is_settings_button")) { td.setAttribute("rowspan", 2) }
                else if (!td.querySelector(".is_settings_uprs")) { td.remove() }
            })
        },

        round2(value)
        {
            return api.round2(value)
        }
    }
}
</script>

<style scoped>
.sales
{
    position: relative;
    width: 100%;
    overflow-x: auto;
}

.sales >>> header, .factors-frame
{
    position: sticky;
    left: 0;
}

.factors-frame
{
    z-index: 5;
}

.sales-corrections_navbar
{
    position: sticky;
    top: -1px;
    left: 0;
    z-index: 3;
    padding-inline: 0;
    justify-content: space-between;
}

.table_analogues >>> thead
{
	position: sticky;
	top: 55px;
	z-index: 3;
}

* >>> .table_analogues th:has(.sticky-col),
* >>> .table_analogues td:has(.sticky-col),
* >>> .table_analogues tfoot .tfoot-td_sticky
{
    position: sticky;
    background-color: white;
    z-index: 2;
}

* >>> .table_analogues th:has(.sticky-col.button_col),
* >>> .table_analogues td:has(.sticky-col.button_col),
* >>> .table_analogues tfoot .tfoot-td_sticky.button_col
{
    left: 1px;
    border-right: none !important;
}

* >>> .table_analogues th:has(.sticky-col.attr_col),
* >>> .table_analogues td:has(.sticky-col.attr_col)
{
    left: 65px;
    border-left: 1px solid var(--bft-blue-200) !important;
    border-right: none !important;
}

* >>> .table_analogues th .attr_col
{
    width: 240px;
}

* >>> .table_analogues th:has(.sticky-col.ref_obj_col),
* >>> .table_analogues td:has(.sticky-col.ref_obj_col),
* >>> .table_analogues tfoot .tfoot-td_sticky.ref_obj_col
{
    left: 337px;
    border-left: 1px solid var(--bft-blue-200) !important;
}

* >>> .table_analogues td:has(.is_attr)
{
    background-color: var(--bft-blue-50);
}

* >>> .table_analogues .tfoot-td_uprs
{
    border-right: none !important;
}

.table_analogues_group-code
{
    display: flex;
    width: 176px;
    word-break: break-all;
}

.table_analogues_group-code a
{
    word-break: break-all;
}
</style>
